import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import type { CaseListItem } from '../../my-cases.types';

@Component({
  selector: 'op-case-list',
  imports: [MatIconModule],
  templateUrl: './case-list.component.html',
  styleUrl: './case-list.component.scss',
})
export class CaseListComponent {
  @Input() cases: CaseListItem[] = [];
  @Input() searchQuery = '';
  @Output() caseSelected = new EventEmitter<string>();
  @Output() searchQueryChange = new EventEmitter<string>();

  avatarColor(name: string): string {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
      hash |= 0;
    }
    return `hsl(${Math.abs(hash) % 360}, 55%, 40%)`;
  }
}
